import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import CTABanner from "../components/CTABanner";
import { SectionLabel } from "../components/Shared";
import { CLIENTS, IMAGES } from "../config/siteConfig";

export default function ClientsPage() {
  return (
    <>
      <PageHero
        label="Our Clients"
        title="Partnerships built on"
        highlight="honesty and connection."
        subtitle="We believe in creating partnerships based on honesty and true connection. That's why some of the biggest companies stayed with us for years."
        image={IMAGES.gcc}
      />
      <section className="bg-[#F7F7F5] py-24 md:py-36" data-testid="clients-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionLabel>Client Portfolio</SectionLabel>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight text-[#111111] mb-4">
            Our <span className="text-[#C62828]">Clients</span>
          </h2>
          <p className="font-body text-[#555] mb-12 max-w-2xl">
            Delivered close to 400 projects to clients across the globe — logos and case notes from our portfolio.
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {CLIENTS.map((c) => (
              <article
                key={c.name}
                data-testid={`client-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="bg-white border border-black/10 rounded-sm p-7 hover:border-[#C62828] hover:shadow-[0_18px_40px_-24px_rgba(198,40,40,0.5)] transition-all duration-400 flex flex-col"
              >
                <div className="h-24 mb-6 flex items-center justify-center bg-[#F7F7F5] rounded-sm border border-black/5 px-4">
                  {c.logo ? (
                    <img
                      src={c.logo}
                      alt={`${c.name} logo`}
                      className="max-h-16 max-w-full object-contain"
                      loading="lazy"
                    />
                  ) : (
                    <span className="font-accent uppercase tracking-widest text-xs text-[#999]">INRISOFT</span>
                  )}
                </div>
                <h3 className="font-body font-600 text-lg text-[#111111] mb-3">{c.name}</h3>
                <p className="font-body text-[#555] text-sm leading-relaxed flex-1">{c.desc}</p>
              </article>
            ))}
          </div>

          <Link
            to="/contact"
            data-testid="clients-contact-cta"
            className="inline-flex items-center gap-2 mt-14 font-accent uppercase tracking-widest text-sm text-[#C62828] hover:text-[#111111] transition-colors"
          >
            Get in Touch →
          </Link>
        </div>
      </section>
      <CTABanner heading="Ready to start your project?" highlight="Get in Touch." secondary={null} />
    </>
  );
}
